module.exports = __webpack_public_path__ + "img/bottom_right_img.29ffb14f.png";